<div class="px-3">
    <cv-loader [overlay]="false" [hidden]="!isLoadingPermissionGroupForEmp && !isLoadingPermissionGroupForRec"></cv-loader>
    <div class="permissionsGroupBorder" *ngFor="let el of permission_display">
        <div class="row color-whaleTail">
            <div class="lato-bold h7"> {{el[0][0].type}}</div>
        </div>
        <div class="row content p-3">
            <div class="col-6">
                <div class="row section-header">
                    <span class="color-whaleTail lato-bold" cvLocalizedText langSection="Users" langKey="Employee">Employee</span>
                </div>
                <div *ngFor="let atom of el[0]" class="my-2">
                    <div class="row">
                        <span class="color-valyrianSteel">{{atom.name}}</span>
                        <span *ngIf="atom.Default" class="permissionsAttributeLabel default_group">
                            &nbsp;&nbsp;&nbsp;
                            <span class="font-size-11" cvLocalizedText langSection="Users" langKey="Default_From_Role">Default from Role</span>
                        </span>
                    </div>
                    <div class="row">
                        <span class="color-whaleTail">{{(atom.tree == "")? "N/A": atom.tree}}</span>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="row section-header d-flex justify-content-between">
                    <span class="color-whaleTail lato-bold" cvLocalizedText langSection="Users" langKey="Contact">Contact</span>
                    <button type="button" class="icon-btn fill-cerulean fill-hover-ceruleanHover mt-n3"
                            [disabled]="isLoadingPermissionGroupForEmp || isLoadingPermissionGroupForRec"
                            (click)="editPermission(el[0][0].type, el[1][0].ModuleID)">
                        <svg class="icon-16">
                            <use href="../../../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use>
                        </svg>
                    </button>
                </div>
                <div *ngFor="let atom of el[1]" class="my-2">
                    <div class="row">
                        <span class="color-valyrianSteel">{{atom.name}}</span>
                        <span *ngIf="atom.Default" class="permissionsAttributeLabel default_group">
                            &nbsp;&nbsp;&nbsp;
                            <span class="font-size-11" cvLocalizedText langSection="Users" langKey="Default_From_Role">Default from Role</span>
                        </span>
                    </div>
                    <div class="row">
                        <span class="color-whaleTail">{{(atom.tree == "")? "N/A": atom.tree}}</span>
                    </div>
                </div>
            </div>
        </div>
        <br />
    </div>
</div>
<!-- Permission Assigning Page -->
<cv-angular-assign-tool [showAll]="true" [singleAdd]="true" [singleType]="true" [showParent]="false" [headerText]="localizationDic.get('Assign_Tool_Header')"
                        buttonText="Save" type="permission assignments" [(showPopup)]="showPopup" [dataTransfer]="permission_inner_right_display"
                        (SavePermissionGroupEvent)="onPermissionSave($event)" showTypes="emp rec"></cv-angular-assign-tool>
